import { useMemo } from 'react';
import useMsftVendorSettings from '../../hooks/useMsftVendorSettings';
import { SectionSingleSelectField } from './SectionFields';
import { FieldEnum } from './sectionSchema';

const SelectPartnerLocation = () => {
  const { data: vendorSettings, isInitialLoading } = useMsftVendorSettings();

  const partnerLocationOptions = useMemo(() => {
    if (!vendorSettings?.partnerLocations?.length) return [];
    return vendorSettings?.partnerLocations.map((location) => ({
      display: location.name,
      value: location.mpnId,
    }));
  }, [vendorSettings]);

  return (
    <SectionSingleSelectField
      disabled={isInitialLoading || !partnerLocationOptions.length}
      name={FieldEnum.mpnId}
      options={partnerLocationOptions}
    />
  );
};

export default SelectPartnerLocation;
